(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("icon-sdk-js", [], factory);
	else if(typeof exports === 'object')
		exports["icon-sdk-js"] = factory();
	else
		root["icon-sdk-js"] = factory();
})(this, () => {
return 